import { ToolOutlined } from "@ant-design/icons";
import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as ToolDesignPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/design";
import { Route as ToolScenarioPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario";
import { Route as ToolStructurePage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure";
import { Route as TrackingToolsPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/tool/")({
    component: ToolsPage,
    staticData: {
        permissions: [
            PermissionEnum.ToolStructureForm,
            PermissionEnum.ToolStructureFeed,
            PermissionEnum.ToolStructureUser,
            PermissionEnum.ToolIntegration,
            PermissionEnum.ToolScenarioField,
            PermissionEnum.ToolDesignForm,
            PermissionEnum.ToolDesignScreen,
            PermissionEnum.ToolDesignFunnel,
            PermissionEnum.ToolTrackingIncoming,
            PermissionEnum.ToolTrackingOutgoing,
        ],
        showInSideMenu: true,
        label: "pages.tool.title",
        icon: <ToolOutlined />,
        sort: 6,
        redirects: [ToolStructurePage, ToolDesignPage, ToolScenarioPage, TrackingToolsPage],
        defaultRedirect: ToolStructurePage,
    },
});

function ToolsPage() {
    return <RedirectPage />;
}
